<template>
  <div :class="cn('flex flex-1 flex-col rounded-xl bg-neutral-100', row.class, props.class)">
    <div
      class="mt-4 flex items-center justify-start gap-1.5 px-5 text-sm font-medium md:text-base"
      v-if="row.header"
    >
      <UiNuxtIcon v-if="row.icon" filled :name="row.icon" />
      <UiSkeleton :loading="isLoading" :classes="{ line: 'my-0.5 h-4 w-24' }">
        {{ row.header }}
      </UiSkeleton>
    </div>

    <div class="flex w-full gap-4 p-5 md:flex-col">
      <div
        class="basis-1/2 border-neutral-400 first:border-e md:first:border-b md:first:border-e-0 first:md:pb-4"
        v-for="(item, index) in row.values"
        :key="index"
      >
        <div class="flex flex-col justify-start gap-1 md:flex-row-reverse md:justify-between">
          <UiSkeleton :loading="isLoading" :classes="{ container: 'w-auto', line: 'h-8 w-24' }">
            <p class="text-lg font-medium md:text-base">{{ item.value }}</p>
          </UiSkeleton>

          <UiSkeleton
            :loading="isLoading"
            :classes="{
              container: 'block pe-4',
              slot: 'flex flex-row items-center gap-1 pe-4',
              line: 'h-5 w-48',
            }"
            slot-tag="p"
          >
            <span class="text-sm font-light text-black/50">{{ item.name }}</span>

            <OverviewBuilderInfoPopupButton
              v-if="item.infoPopup"
              :info-popup="item.infoPopup"
              :classes="{
                infoTrigger: 'flex translate-y-0 items-center justify-center',
              }"
            />
          </UiSkeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ValuePropositionTableRow } from "@finq/pension-portfolio/types/value-proposition"

const props = defineProps<{
  class?: ClassValue
  row: ValuePropositionTableRow
  isLoading?: boolean
}>()
</script>
